import { createSlice } from "@reduxjs/toolkit"

  export const searchSlice = createSlice({
    name: 'search',
    initialState:{searchList:[]},
    reducers: {
      setSearchlist:(state, action) => {
        state.searchList = action.payload;
      },
    },
  })
  
  export const {setSearchlist} = searchSlice.actions
  
  export default searchSlice.reducer